<template>
  <!-- Start Containerbar -->
  <div id="containerbar">
    <!-- Start Rightbar -->
    <div class="rightbar">
      <!-- Start Breadcrumbbar -->
      <div class="breadcrumbbar">
        <div class="row align-items-center">
          <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12">
            <h4 class="page-title">Configuración</h4>
            <div class="breadcrumb-list">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/dashboard">Inicio</a></li>
                <li class="breadcrumb-item">
                  <a @click="changeAction(1)">Configuración</a>
                </li>
                <li class="breadcrumb-item">{{ title }}</li>
              </ol>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12 content-button">
            <button
              class="btn btn-outline-success"
              v-if="showAction(2) || showAction(3)"
              @click="changeAction(1)"
            >
              <i class="ti-arrow-left mr-2"></i> Regresar
            </button>
          </div>
        </div>
      </div>
      <div class="contentbar">
        <div class="row">
          <div class="col-lg-12 col-xl-12">
            <div class="card">
              <AlertMessageComponent ref="alertMessageComponent" />
              <div class="card-header">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title">
                      <i
                        class="feather icon-layout mr-1"
                        aria-hidden="true"
                      ></i>
                      {{ title }}
                    </h5>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <v-alert
                      class="br"
                      icon="feather icon-alert-circle"
                      text
                      type="info"
                      outlined
                      >Para asegurarnos de que los porcentajes en el Tablero de
                      Control de Abasto sean precisos, solo se tomarán en cuenta
                      las sucursales asignadas. Esto significa que cualquier
                      otra sucursal que no haya sido asignada no será
                      considerada en el conteo.</v-alert
                    >
                  </div>
                  <div class="col-md-12">
                    <BranchOfficeCommon
                      ref="get_listBranchOfficeUser"
                      :userListBranchOffice="abastoListBranchOffice"
                    />
                  </div>
                  <div class="col-md-12 text-right">
                    <button
                      class="btn btn-outline-success br"
                      @click="toAssingDashboard()"
                    >
                      <i class="feather icon-save mr-1"></i> Modificar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BranchOfficeCommon from "@/common/branchOffice/BranchOfficeCommon";
import { SwalConfirm } from "@/core/SwalAlert";
import AlertMessageComponent from "@/common/message/AlertMessageComponent";

import { ConfigurationRequest } from "@/core/request";
import { UtilFront } from "@/core";
export default {
  data() {
    return {
      action: 1,
      /** * @member {Object} abastoListBranchOffice Listado de sucursales activas para el tablero de abasto */
      abastoListBranchOffice: [],
      loading: false,
    };
  },
  computed: {
    title() {
      return this.action == 1
        ? "Configuración de tablero de control Abasto"
        : this.action == 2
        ? "Asignación de Tablero de Control Abasto"
        : "";
    },
  },
  methods: {
    alert(type, message) {
      this.$refs.alertMessageComponent.reloadComponent(type, message);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      action == 1 && this.clear();
      this.action = action;
    },
    /**
     * Obtine las sucursales asignas y eliminadas del componente global de sucursales
     * y actualiza las sucursales que toma en cuenta el tablero de control de abasto
     * @method
     */
    async toAssingDashboard() {
      /** Este es un método que está en el componente BranchOfficeCommon.vue, 
       que devuelve un objeto con las sucursales añadidas y eliminadas. */
      let branch = await this.$refs.get_listBranchOfficeUser.getListBranchOfficeUser();
      if (branch == undefined) return;
      const { isConfirmed } = await SwalConfirm.fire({
        icon: "warning",
        title: "Tablero de Control Abasto",
        html:
          "La sucursales asignadas serán tomadas en cuenta en el Tablero de Control de Abasto",
      });
      if (!isConfirmed) {
        return;
      }
      // Creación de un objeto con las sucursales añadidas y eliminadas.
      let data = {
        branchOfficesAdd: branch.branchOfficesAdd,
        branchOfficesDelete: branch.branchOfficesDelete,
      };
      this.loading = UtilFront.getLoadding();
      // Una función asíncrona que espera la respuesta del servidor.
      await ConfigurationRequest.updateBranchOfficeAbasto(data)
        .then((res) => {
          let { data } = res;
          if (!data.undefined) {
            this.loading.hide();
            this.alert("success", "Success_Configuration_0003");
            this.getAllBranchOfficeAbasto();
          }
        })
        .catch((error) => {
          console.log(error);
          this.alert("error", error.message);
        })
        .finally(() => {
          this.loading.hide();
        });
    },
    /**
     * Obtiene todas las sucursales de la base de datos que son tomadas en
     * cuenta para el tablero de control de abasto
     * y las almacena en la variable abastoListBranchOffice.
     * @method
     */
    async getAllBranchOfficeAbasto() {
      this.loading = UtilFront.getLoadding();
      await ConfigurationRequest.getAllBranchOfficeAbasto()
        .then((res) => {
          let { data } = res;
          if (data) {
            this.abastoListBranchOffice = data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.alert("error", error.message);
        })
        .finally(() => {
          this.loading.hide();
        });
    },
  },
  watch: {},
  async created() {
    await this.getAllBranchOfficeAbasto();
  },
  components: {
    BranchOfficeCommon,
    AlertMessageComponent,
  },
};
</script>
